import gameObjectsSettings from '../constants/gameObjectsSettings/gameObjectsSettings';
import gameObjectTypes from '../constants/gameObjectTypes';
import { incrementPxToCoord, getIsGamePt } from '../constants/gameSettings';
// import { incrementPxToCoord } from '../constants/gameSettings';

export default class CharacterModel {
    #isPt = false;

    #position = {
        x: 0,
        y: 0
    };

    #startPoint = {
        x: 0,
        y: 0
    };

    #maxOffsetByX;
    speedOfSpriteSheetSeconds;

    get position() {
        return this.#position;
    }

    get startPoint() {
        return this.#startPoint;
    }

    constructor() {
        this.#isPt = getIsGamePt();
        this.updatePositionAndOffset();
    }

    updatePositionAndOffset() {
        let startPoint = null;

        if (this.#isPt) {
            this.#maxOffsetByX = gameObjectsSettings[gameObjectTypes.MAIN_CHARACTER].maxOffsetByXPt;
            startPoint = { ...gameObjectsSettings[gameObjectTypes.MAIN_CHARACTER].startPointPt };
        } else {
            this.#maxOffsetByX = gameObjectsSettings[gameObjectTypes.MAIN_CHARACTER].maxOffsetByX;
            startPoint = { ...gameObjectsSettings[gameObjectTypes.MAIN_CHARACTER].startPoint };
        }

        this.#startPoint = { x: startPoint.x * incrementPxToCoord, y: startPoint.y * incrementPxToCoord };

        // console.log(this.#startPoint);

        // Нужно для поиска пересечений
        this.#position = { x: startPoint.x * incrementPxToCoord, y: startPoint.y * incrementPxToCoord };
        // console.log(`POSITIONX: ${this.#position.x}`);
    }

    updateSpeedOfSpriteSheet(gameVelocity) {
        this.speedOfSpriteSheetSeconds = gameVelocity === 0 ? gameVelocity : Math.min(3 / gameVelocity, 0.5);
    }

    updateGameSizes() {
        // todo вынести параметр
        this.#isPt = getIsGamePt();
        this.updatePositionAndOffset();
    }

    setPosition(x, y) {
        this.#position = {
            x,
            y
        };
    }

    move(movementVector, offsetValueAtOneStep) {
        // console.log(`POSITIONX: ${this.#position.x}`);
        const moveVector = movementVector.multiplyingByNumber(offsetValueAtOneStep);

        if (Math.abs(this.#position.x + moveVector.x) >= this.#maxOffsetByX) return;

        this.#position = {
            x: this.#position.x + moveVector.x,
            y: this.#position.y + moveVector.y
        };
    }
}
